import {
  ref,
  listAll,
  getStorage,
  uploadBytes,
  deleteObject,
  getDownloadURL,
} from 'firebase/storage';

import { firebaseApp } from '../';

// ----------------------------------------------------------------------

export const STORAGE = getStorage(firebaseApp);

export const getFiles = async (folder = '_draft/') => {
  const files = await listAll(ref(STORAGE, folder));
  const urlFiles = await Promise.all(files?.items?.map(getDownloadURL));
  return urlFiles;
};

export const uploadFiles = async (files, folder = '_draft/') => {
  const urlFiles = files
    ? await Promise.all(
        [...files].map(async (file, index) => {
          const fileName = `${index}.${file.type.split('/')[1]}`;
          const storageRef = ref(STORAGE, `${folder}${fileName}`);
          await uploadBytes(storageRef, file, { contentType: file.type });
          const downloadURL = await getDownloadURL(storageRef);
          return downloadURL;
        })
      )
    : [''];

  return urlFiles;
};

export const deleteFile = async (file = '_draft/0.jpg') => {
  await deleteObject(ref(STORAGE, file));
};

export const deleteFolder = async (folder = '_draft/') => {
  const list = await listAll(ref(STORAGE, folder));
  const deletePromises = [
    ...(list?.items ?? []).map((itemRef) => itemRef && deleteObject(itemRef)),
    ...(list?.prefixes ?? []).map((folderRef) => folderRef && deleteObject(folderRef)),
  ];
  await Promise.all(deletePromises);
};
